'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSupplementalInitialMessagesSucceeded = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.stageSupplementalInitialMessages = stageSupplementalInitialMessages;

var _buildSender = require('conversations-schema/common-message-format-conversion/operators/buildSender');

var _cmfSenderInterop = require('conversations-schema/common-message-format-conversion/operators/cmfSenderInterop');

var _cmfSenderTypes = require('conversations-schema/common-message-format/constants/cmfSenderTypes');

var _QuickReplyAttachment = require('conversations-schema/common-message-format/records/QuickReplyAttachment');

var _QuickReplyAttachment2 = _interopRequireDefault(_QuickReplyAttachment);

var _HttpStatusCodes = require('conversations-schema/constants/HttpStatusCodes');

var _MessageDescriptorSources = require('conversations-schema/constants/MessageDescriptorSources');

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _buildInitialMessage = require('conversations-schema/initial-message/operators/buildInitialMessage');

var _timestamps = require('conversations-schema/lib/timestamps');

var _messageTypes = require('conversations-schema/pubnub-message/constants/messageTypes');

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _reduxActions = require('redux-actions');

var _getIsWidgetInAwayMode = require('../../availability/selectors/getIsWidgetInAwayMode');

var _fetchSupplementalInitialMessages = require('../../clients/fetchSupplementalInitialMessages');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _isUngatedForInitialMessage = require('../../gates/selectors/isUngatedForInitialMessage');

var _getAssignedResponderInWidget = require('../../responders/selectors/getAssignedResponderInWidget');

var _getSelectedThread = require('../../selected-thread/selectors/getSelectedThread');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _stageMessageOnStubbedThread = require('../../stubbed-thread-history/actions/stageMessageOnStubbedThread');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchSupplementalInitialMessagesStarted = (0, _reduxActions.createAction)(ActionTypes.GET_SUPPLEMENTAL_INITIAL_MESSAGES);

var fetchSupplementalInitialMessagesSucceeded = exports.fetchSupplementalInitialMessagesSucceeded = (0, _reduxActions.createAction)(ActionTypes.GET_SUPPLEMENTAL_INITIAL_MESSAGES_SUCCEEDED);

var fetchSupplementalInitialMessagesFailed = (0, _reduxActions.createAction)(ActionTypes.GET_SUPPLEMENTAL_INITIAL_MESSAGES_FAILED, function (error) {
  return { error: error };
});

function stageSupplementalInitialMessages() {
  return function (dispatch, getState) {
    var state = getState();
    if ((0, _getIsWidgetInAwayMode.getIsWidgetInAwayMode)(state)) {
      return _q2.default.Promise.resolve();
    }

    var responder = (0, _getAssignedResponderInWidget.getAssignedResponderInWidget)(state);
    var botId = (0, _responderGetters.getUserId)(responder);
    var sessionId = (0, _getSessionId.getSessionId)(state);
    var currentConversation = (0, _getSelectedThread.getSelectedThread)(state);
    var source = (0, _threadGetters.getSource)(currentConversation);

    dispatch(fetchSupplementalInitialMessagesStarted());

    return (0, _fetchSupplementalInitialMessages.fetchSupplementalInitialMessages)({ botId: botId, sessionId: sessionId }).then(function (response) {
      var messageContainers = response.status === _HttpStatusCodes.NO_CONTENT ? [] : response.data;

      dispatch(fetchSupplementalInitialMessagesSucceeded());

      messageContainers.forEach(function (_ref) {
        var message = _ref.message;

        if ((0, _isUngatedForInitialMessage.isUngatedForInitialMessage)(state)) {
          var attachments = [];

          var quickReply = (0, _pubnubMessageGetters.getQuickReply)(message);
          if (quickReply) {
            attachments.push(new _QuickReplyAttachment2.default(quickReply));
          }
          var unpublishedInitialMessage = (0, _buildInitialMessage.buildInitialMessage)({
            id: message.id,
            clientType: message.clientType,
            sender: (0, _buildSender.buildSender)({
              senderType: (0, _cmfSenderInterop.toCmfSender)(message.senderType) || _cmfSenderTypes.BOT_SENDER,
              senderId: message.senderId
            }),
            status: source ? _extends({}, message.status, {
              source: source
            }) : null,
            attachments: attachments,
            text: (0, _pubnubMessageGetters.getText)(message),
            richText: (0, _pubnubMessageGetters.getRichText)(message),
            timestamp: (0, _timestamps.generateUniqueClientTimestamp)()
          });

          dispatch((0, _stageMessageOnStubbedThread.stageMessageOnStubbedThread)(unpublishedInitialMessage));
        } else {
          delete message.clientTs;
          delete message.timestamp;

          // Patch around invalid type returned by livechat/v1/bots/bot/{botId}/welcomeMessages
          message.metadata[_messageTypes.MESSAGE_TYPE_ID] = _messageTypes.INITIAL_MESSAGE;

          var _unpublishedInitialMessage = (0, _buildUnpublishedMessage.buildUnpublishedMessage)(_extends({}, message, {
            descriptor: { source: _MessageDescriptorSources.SUPPLEMENTAL_INITIAL_MESSAGE }
          }));

          dispatch((0, _stageMessageOnStubbedThread.stageMessageOnStubbedThread)(_unpublishedInitialMessage));
        }
      });
    }, function (error) {
      dispatch(fetchSupplementalInitialMessagesFailed(error));
    });
  };
}